import React from 'react';
import {useStyles} from './style';
import CssBaseline from '@material-ui/core/CssBaseline';
import {AppBar, Toolbar} from '@material-ui/core';

export default function Footer() {
    const classes = useStyles();
    const   fbLogo = "/assets/fb-logo.png",
    TwLogo="/assets/twitter.svg",
    YtLogo="/assets/youtube.svg",
    Logo="/assets/WhiteIcon.svg";

    return (
    <React.Fragment>
        <CssBaseline />        
        <AppBar className={classes.appBar}>
            <Toolbar variant="dense">
                <img className={classes.img} src={Logo} alt="facebook Qmi Teaches"/>
                <p className={classes.title}>
                    Tribunal Supremo Electoral. Guatemala, C.A.
                </p>
                {/* <img className={classes.imgTwo} src={fbLogo} alt="facebook Qmi Teaches"/>
                <img className={classes.imgTwo} src={YtLogo} alt="youtube"/>
                <img className={classes.imgTwo} src={TwLogo} alt="twitter"/>   */}
                {/* <p className={classes.lastTitle}>Guatemala, C.A.</p> */}
            </Toolbar>
        </AppBar>
    </React.Fragment>
    );
}
